import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { GetAreaApi } from "../AddArea/areaAction";
import { AddShopApi } from "./Shop.action";
import { getUserRes } from "../../AddUser/user.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { GetLevelAccountTypeApi } from "../../AccountsModule/LevelFour/LevelFourAction";
import _ from "lodash";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddShop = (props) => {
  const [areaName, setAreaName] = useState("");
  const [areaId, setAreaId] = useState();
  const [shopName, setShopName] = useState("");
  const [shopDesc, setShopDesc] = useState("");
  const [shopLocation, setShopLocation] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [ownerNumber, setOwnerNumber] = useState("");
  const [ownerCNIC, setOwnerCNIC] = useState("");
  const [accountTypeId, setAccountTypeId] = useState();
  const [accountTypeName, setAccountTypeName] = useState();
  const [shopBalance, setShopBalance] = useState("");
  const [salesmenId, setSalesmenId] = useState("");
  const [salesmenName, setSalesmenName] = useState("");
  const [activeStatus, setActiveStatus] = useState(true);

  function SaveShop() {
    props.AddShopApi({
      shopName: shopName,
      shopDesc: shopDesc,
      location: shopLocation,
      ownerName: ownerName,
      ownerNumber: ownerNumber,
      ownerCnic: ownerCNIC,
      debitCreditId: accountTypeId,
      shopBalance: Number(shopBalance),
      salesmenId: salesmenId,
      salesmenName: salesmenName,
      filerStatus: activeStatus,
      areaDetails: {
        _id: areaId,
        areaName: areaName,
      }
    },
      showSuccessAlert,
      showErrorAlert,
    );
    setAreaName("")
    setShopName("")
    setShopDesc("")
    setShopLocation("")
    setOwnerName("")
    setOwnerCNIC("")
    setOwnerNumber("")
    setAccountTypeId("")
    setAccountTypeName("")
    setShopBalance("")
    setSalesmenId("")
    setSalesmenName("")
    setActiveStatus("")
  }

  const handleChangeAccountType = (selectedOption) => {
    setAccountTypeId(selectedOption.value);
    setAccountTypeName(selectedOption.label);
  };
  const getAccountTypeList = _.isEmpty(props.accountTypeList) ? [] : props.accountTypeList.map((x) => {
    let data = { value: x._id, label: x.account_type_name };
    return data;
  });

  const handleChangeArea = (selectedOption) => {
    setAreaId(selectedOption.value);
    setAreaName(selectedOption.label);
  };
  const AreaListData = _.isEmpty(props.areaDataList) ? [] : props.areaDataList.map((x) => {
    let data = { value: x._id, label: x.areaName };
    return data;
  });

  const handleChangeSalemen = (selectedOption) => {
    setSalesmenId(selectedOption.value);
    setSalesmenName(selectedOption.label);
  };
  const SalesmanList = _.isEmpty(props.userList) ? [] : props.userList.filter(x => x.role === "booker").map((x) => {
    let data = { value: x._id, label: x.userName };
    return data;
  });

  const getStatusList = [
    { value: true, label: "Active" },
    { value: false, label: "Non Active" },
  ];
  const handleChangeStatus = (selectedOption) => {
    setActiveStatus(selectedOption.value);
  };

  useEffect(() => {
    props.setHeading("Add Shop");
    props.GetAreaApi();
    props.GetLevelAccountTypeApi();
    props.getUser();
  }, []);

  return (
    <>
      {props.isAddingShop || props.isFetchingAccountType || props.isFetchingAreaData || props.isFetchingUserList ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Area *</b></Form.Label>
                <Select
                  placeholder="Select Area"
                  onChange={handleChangeArea}
                  options={AreaListData}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Salesman *</b></Form.Label>
                <Select
                  placeholder="Select Salesman"
                  onChange={handleChangeSalemen}
                  options={SalesmanList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Filer Status *</b></Form.Label>
                <Select
                  placeholder="Select Filer Status"
                  onChange={handleChangeStatus}
                  options={getStatusList}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Shop Name *</b></Form.Label>
                <Form.Control
                  value={shopName}
                  type="text"
                  placeholder="Shop Name"
                  onChange={(e) => { setShopName(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Shop Location *</b></Form.Label>
                <Form.Control
                  type="text"
                  value={shopLocation}
                  placeholder="Shop Location"
                  onChange={(e) => { setShopLocation(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Balance Type *</b></Form.Label>
                <Select
                  placeholder="Balance Type"
                  onChange={handleChangeAccountType}
                  options={getAccountTypeList}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Shop Balance *</b></Form.Label>
                <Form.Control
                  type="number"
                  value={shopBalance}
                  placeholder="Shop Balance"
                  onChange={(e) => { setShopBalance(e.target.value) }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Owner Name </b></Form.Label>
                <Form.Control
                  type="text"
                  value={ownerName}
                  placeholder="Owner Name"
                  onChange={(e) => { setOwnerName(e.target.value) }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Contact Number</b></Form.Label>
                <Form.Control
                  value={ownerNumber}
                  type="text"
                  placeholder="Contact Number"
                  onChange={(e) => { setOwnerNumber(e.target.value); }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Description</b></Form.Label>
                <Form.Control
                  value={shopDesc}
                  type="text"
                  placeholder="Description"
                  onChange={(e) => { setShopDesc(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>CNIC / NTN</b></Form.Label>
                <Form.Control
                  value={ownerCNIC}
                  type="text"
                  placeholder="CNIC / NTN"
                  onChange={(e) => { setOwnerCNIC(e.target.value); }}
                />
              </Form.Group>
            </Col>
            <Col></Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(areaName) || _.isEmpty(salesmenName) || _.isEmpty(accountTypeName) || _.isEmpty(shopName) || _.isEmpty(shopLocation) || _.isEmpty(shopBalance) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveShop}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddShopApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddShopApi(data, showSuccessAlert, showErrorAlert)),
    GetAreaApi: () => dispatch(GetAreaApi()),
    GetLevelAccountTypeApi: () => dispatch(GetLevelAccountTypeApi()),
    setHeading: (data) => dispatch(setHeading(data)),
    getUser: () => dispatch(getUserRes())
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingShop: state.ShopReducer.isAddingShop,
  isFetchingAccountType: state.LevelFourReducer.isFetchingAccountType,
  accountTypeList: state.LevelFourReducer.accountTypeList,
  isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
  areaDataList: state.AreaReducer.areaDataList,
  isFetchingUser: state.UserReducer.isFetchingUser,
  userList: state.UserReducer.userList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddShop);
